import React from "react";
import { Checkbox, FormControl, ListItemText, MenuItem, Select } from "@mui/material";
import CommonFieldWrapper from "../CommonFieldWrapper/CommonFieldWrapper";

const CommonSelect = ({
  label,
  name,
  id,
  value,
  options = [],
  placeholder,
  onChange,
  required = false,
  disabled = false,
  error = "",
  isMulti = false,
  className,
  styles = {},
  showLabel = true,
  inputProps = undefined,
  renderValue,
  renderOption,
}) => {
  const {
    wrapperSx,
    labelStyle,
    selectSx,
    errorSx,
    checkboxSx,
    menuItemSx,
    optionTextProps,
  } = styles;

  const defaultRenderValue = (selected) => {
    if (isMulti) {
      return selected.length ? selected.join(", ") : placeholder;
    }
    return selected || placeholder;
  };

  return (
    <CommonFieldWrapper
      label={label}
      required={required}
      labelStyle={labelStyle}
      error={error}
      errorSx={errorSx}
      wrapperSx={wrapperSx}
      showLabel={showLabel}
      className={className}
    >
      <FormControl fullWidth>
        <Select
          id={id}
          multiple={isMulti}
          displayEmpty
          name={name}
          disabled={disabled}
          value={value}
          onChange={onChange}
          renderValue={renderValue || defaultRenderValue}
          sx={selectSx}
          inputProps={inputProps}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option} sx={menuItemSx}>
              {renderOption ? (
                renderOption(option)
              ) : isMulti ? (
                <>
                  <Checkbox
                    checked={Array.isArray(value) && value.includes(option)}
                    size="small"
                    sx={checkboxSx}
                  />
                  <ListItemText
                    primary={option}
                    primaryTypographyProps={optionTextProps}
                  />
                </>
              ) : (
                option
              )}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </CommonFieldWrapper>
  );
};

export default CommonSelect;
